import { Competitor } from "~src/types/product";
import { LatestTrafficData } from "../brands/Detail/TrafficAndRevenue";

export const getComparisonReport = (competitor: Competitor) => {
  return [
    {
      label: "IG Followers",
      value: competitor.ig_followers,
    },
    {
      label: "FB Likes",
      value: competitor.fb_likes,
    },
    {
      label: "FB Ads Active",
      value: competitor.fb_ads_active,
    },
    {
      label: "Google Ads Active",
      value: competitor.google_ads_active,
    },
    {
      label: "Website Traffic Approx",
      value: competitor.web_traffic,
    },
  ];
};

export const getLatestData = (
  data: Record<string, Record<string, string>>,
): any => {
  const dataArray: [string, Record<string, string>][] = Object.entries(data);

  if (dataArray.length === 0) {
    return undefined;
  }

  dataArray.sort(
    ([dateA], [dateB]) => new Date(dateB).getTime() - new Date(dateA).getTime(),
  );

  return dataArray[0][1] as LatestTrafficData;
};
